/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrivateCustomerConsent
 */
export interface PrivateCustomerConsent {
    /**
     * 
     * @type {boolean}
     * @memberof PrivateCustomerConsent
     */
    sofortigerBeginnAccepted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivateCustomerConsent
     */
    widerrufsrechtAccepted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PrivateCustomerConsent
     */
    acceptedAt?: Date;
}

/**
 * Check if a given object implements the PrivateCustomerConsent interface.
 */
export function instanceOfPrivateCustomerConsent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrivateCustomerConsentFromJSON(json: any): PrivateCustomerConsent {
    return PrivateCustomerConsentFromJSONTyped(json, false);
}

export function PrivateCustomerConsentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivateCustomerConsent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sofortigerBeginnAccepted': !exists(json, 'sofortigerBeginnAccepted') ? undefined : json['sofortigerBeginnAccepted'],
        'widerrufsrechtAccepted': !exists(json, 'widerrufsrechtAccepted') ? undefined : json['widerrufsrechtAccepted'],
        'acceptedAt': !exists(json, 'acceptedAt') ? undefined : (new Date(json['acceptedAt'])),
    };
}

export function PrivateCustomerConsentToJSON(value?: PrivateCustomerConsent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sofortigerBeginnAccepted': value.sofortigerBeginnAccepted,
        'widerrufsrechtAccepted': value.widerrufsrechtAccepted,
        'acceptedAt': value.acceptedAt === undefined ? undefined : (value.acceptedAt.toISOString()),
    };
}

